var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUspShieldCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/shield-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 7.04923C11.5 9.79877 9.53125 11.1735 7.19125 11.9709C7.06872 12.0115 6.93561 12.0096 6.81438 11.9654C4.46875 11.1735 2.5 9.79877 2.5 7.04923V3.19988C2.5 3.05403 2.55926 2.91416 2.66475 2.81104C2.77024 2.70791 2.91332 2.64997 3.0625 2.64997C4.1875 2.64997 5.59375 1.99008 6.5725 1.15422C6.69167 1.05469 6.84326 1 7 1C7.15674 1 7.30833 1.05469 7.4275 1.15422C8.41188 1.99558 9.8125 2.64997 10.9375 2.64997C11.0867 2.64997 11.2298 2.70791 11.3352 2.81104C11.4407 2.91416 11.5 3.05403 11.5 3.19988V7.04923Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5 7L6.5 8L8.5 6",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspShieldCheck);
export default __webpack_public_path__ + "static/media/usp-shield-check.675676883c97d426fef66ee2fb9a62d5.svg";
export { ForwardRef as ReactComponent };